import React from 'react';
import { withRouteData, Link } from 'react-static';
import Helmet from 'react-helmet';
import { compose } from 'recompose';
import withTracker from '../utils/withTracker';
import Navigation from '../components/WaveNavigation/';
import Directory from '../components/Directory/';

export default compose(withRouteData)(({ directory }) => (
  <div>
    <Helmet
      title='Fire Island Ferries | Business Directory'
      meta={[
        {
          name: 'description',
          content:
            'Fire Island Ferries updates, service notifications, and new schedules.',
        },
        {
          name: 'keywords',
          content: 'Fire Island Ferries, Water Taxi, notifications, updates',
        },
      ]}
    />
    <Navigation />
    <div className='container page'>
      <div className='heading'>
        <h2>Directory</h2>
        <h1>Fire Island Business Directory</h1>
      </div>
      <p>
        Please choose a category below to find Fire Island related businesses.
      </p>
      <Directory list={directory} />
    </div>
  </div>
));
